
import GeographicLib from 'geographiclib';


var MapConvert = function(map) {
    this.map = map;
    this.renderer = map.renderer;
    this.measure = map.measure;
    this.isProjected = this.map.getNavigationSrs().isProjected();
};


MapConvert.prototype.convertCoords = function(coords, source, destination) {
    return this.map.referenceFrame.convertCoords(coords, source, destination);
};


// The view extent scale-dependent vertical exaggeration follows: the
// selection camera's, which is the one terrain is exaggerated for.
MapConvert.prototype.veExtent = function() {
    return this.map.outerMap.selectionCamera.viewExtent;
};


// Heights are measured from the datum throughout: the navigation SRS's
// ellipsoid, or its Z axis on a projected frame.
MapConvert.prototype.getNavCoordsFromPublic = function(coords) {
    return this.convertCoords(coords, 'public', 'navigation');
};


MapConvert.prototype.getPublicCoords = function(coords) {
    return this.convertCoords(coords, 'navigation', 'public');
};


MapConvert.prototype.getPhysCoords = function(coords, includeSE) {
    if (includeSE) {
        var height = this.renderer.getSuperElevatedHeight(
            coords[2], this.veExtent());

        coords = [coords[0], coords[1], height];
    }

    return this.convertCoords(coords, 'navigation', 'physical');
};


MapConvert.prototype.getCameraSpaceCoords = function(coords) {
    coords = [coords[0], coords[1], this.renderer.getSuperElevatedHeight(
        coords[2], this.veExtent())];

    var worldPos = this.convertCoords(coords, 'navigation', 'physical');
    var camPos = this.map.outerMap.camera.geometry.eye;
    worldPos[0] -= camPos[0];
    worldPos[1] -= camPos[1];
    worldPos[2] -= camPos[2];

    // mmm, this does not look like camera space coords to me
    return worldPos;
};


MapConvert.prototype.getCanvasCoords = function(
    coords, physical, containsSE) {

    var worldPos;
    if (physical) {
        var camPos = this.map.outerMap.camera.geometry.eye;

        if (!containsSE) {
            coords = this.renderer.transformPointBySE(
                coords, this.veExtent());
        }

        worldPos = [coords[0] - camPos[0], coords[1] - camPos[1], coords[2] - camPos[2]];
    } else {
        worldPos = this.getCameraSpaceCoords(coords);
    }

    return this.renderer.project2(
        worldPos, this.map.outerMap.camera.geometry.mvp);
};


MapConvert.prototype.transformPhysCoordsBySE = function(coords) {
    return this.renderer.transformPointBySE(coords, this.veExtent());
};


MapConvert.prototype.convertCoordsFromPhysToNav = function(
    coords, containsSE) {

    coords = this.convertCoords(coords, 'physical', 'navigation');

    if (containsSE) {
        coords[2] = this.renderer.getUnsuperElevatedHeight(
            coords[2], this.veExtent());
    }

    return coords;
};


MapConvert.prototype.getGeodesicLinePoints = function(coords, coords2, height, density) {
    var geod, r, length, azimuth, minStep, d;
    var navigationSrsInfo = this.measure.navigationSrsInfo;
    var dx = coords2[0] - coords[0];
    var dy = coords2[1] - coords[1];
    var dz = coords2[2] - coords[2];

    if (this.isProjected) {
        length = Math.sqrt(dx*dx + dy*dy + dz*dz);
        minStep = 1000000; //just big number
    } else {
        geod = this.measure.getGeodesic();
        r = geod.Inverse(coords[1], coords[0], coords2[1], coords2[0]);
        length = r.s12;
        azimuth = r.azi1;
        minStep = 10 * ((navigationSrsInfo['a'] * 2 * Math.PI) / 4007.5); //aprox 100km for earth
    }

    var points = [coords];
    var distance = minStep;

    for (;distance < length; distance += minStep) {
        d = distance / length;

        if (this.isProjected) {
            points.push([ coords[0] + dx * d, coords[1] + dy * d, coords[2] + dz * d ]);
        } else {
            r = geod.Direct(coords[1], coords[0], azimuth, distance);
            points.push([r.lon2, r.lat2, coords[2] + dz * d]);
        }
    }

    points.push(coords2);

    return points;
};

export default MapConvert;
